// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes _12uj2nf4 {
  0% {
    bottom: -200px;
  }
  100% {
    bottom: 0;
  }
}
@keyframes _12uj2nf5 {
  0% {
    bottom: 0;
  }
  100% {
    bottom: -200px;
  }
}
@keyframes _12uj2nf6 {
  0% {
    scale: 0.95;
    opacity: 0;
    visibility: hidden;
  }
  100% {
    scale: 1;
    opacity: 1;
    visibility: visible;
  }
}
@keyframes _12uj2nf7 {
  0% {
    scale: 1;
    opacity: 1;
    visibility: visible;
  }
  100% {
    scale: 0.95;
    opacity: 0;
    visibility: hidden;
  }
}
._12uj2nf0 {
  width: 90%;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-duration: 1s;
}
._12uj2nf1 {
  bottom: 0;
  left: 0;
}
._12uj2nf2 {
  width: 140px;
}
._12uj2nf3 {
  top: -40px;
  width: 40px;
  height: 40px;
}
@media screen and (min-width: 768px) {
  ._12uj2nf0 {
    width: 768px;
  }
  ._12uj2nf1 {
    width: 295px;
    left: unset;
    bottom: unset;
  }
  ._12uj2nf2 {
    width: 295px;
  }
  ._12uj2nf3 {
    top: 0;
    width: 35px;
    height: 35px;
  }
}
@media screen and (min-width: 1024px) {
  ._12uj2nf0 {
    width: 1024px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE;IACE,cAAc;EAChB;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,QAAQ;IACR,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;IACE,QAAQ;IACR,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;AACF;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,qCAAqC;EACrC,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,OAAO;AACT;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,MAAM;IACN,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["@keyframes _12uj2nf4 {\n  0% {\n    bottom: -200px;\n  }\n  100% {\n    bottom: 0;\n  }\n}\n@keyframes _12uj2nf5 {\n  0% {\n    bottom: 0;\n  }\n  100% {\n    bottom: -200px;\n  }\n}\n@keyframes _12uj2nf6 {\n  0% {\n    scale: 0.95;\n    opacity: 0;\n    visibility: hidden;\n  }\n  100% {\n    scale: 1;\n    opacity: 1;\n    visibility: visible;\n  }\n}\n@keyframes _12uj2nf7 {\n  0% {\n    scale: 1;\n    opacity: 1;\n    visibility: visible;\n  }\n  100% {\n    scale: 0.95;\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n._12uj2nf0 {\n  width: 90%;\n  animation-fill-mode: forwards;\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-duration: 1s;\n}\n._12uj2nf1 {\n  bottom: 0;\n  left: 0;\n}\n._12uj2nf2 {\n  width: 140px;\n}\n._12uj2nf3 {\n  top: -40px;\n  width: 40px;\n  height: 40px;\n}\n@media screen and (min-width: 768px) {\n  ._12uj2nf0 {\n    width: 768px;\n  }\n  ._12uj2nf1 {\n    width: 295px;\n    left: unset;\n    bottom: unset;\n  }\n  ._12uj2nf2 {\n    width: 295px;\n  }\n  ._12uj2nf3 {\n    top: 0;\n    width: 35px;\n    height: 35px;\n  }\n}\n@media screen and (min-width: 1024px) {\n  ._12uj2nf0 {\n    width: 1024px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
